<template>
  <vs-row id="globalFilter" vs-type="flex" vs-w="12" class="bg-white" v-if="isActive">
    <vs-row id="globalFilterHeader" vs-type="flex" vs-w="12">
      <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" class="p-2">
        <span class="text-dark weight-600 text-small">
          Filtreler
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" class="p-2">
        <feather-icon icon="XIcon" @click.stop="closeFilter" class="cursor-pointer text-danger"></feather-icon>
      </vs-col>
    </vs-row>
    <vs-row id="globalFilterContent" vs-type="flex" vs-w="12">
      <vs-col v-for="(prop,index) in filterOptions.filter(x=> filterIgnoredProperties.findIndex(y=> y == x) === -1)"
              :key="index" vs-type="flex" vs-w="2.4" vs-sm="6"
              class="px-1 py-1 globalFilterOption" vs-justify="center" vs-align="center">
        <div class="w-full" @click="fillBranchOptions" v-if="prop == 'branch'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Şube Adı
          </span>
          <v-select class="w-full" placeholder="Şube Seçimi" itemid="id" label="name" v-model="localTableOptions.branch"
                    :options="branchNameList" :clearable="true"/>
        </div>
        <div class="w-full" v-else-if="prop == 'dateRange'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Baş. Tarih
              </span>
              <datepicker placeholder="Başlangıç Tarihi" class="w-full filterStartDate" :language="turkish"
                          :format="format" v-model="localTableOptions.dateRange.startDate">
              </datepicker>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Bit. Tarih
              </span>
              <datepicker placeholder="Bitiş Tarihi" class="w-full filterEndDate" :language="turkish" :format="format"
                          v-model="localTableOptions.dateRange.endDate">
              </datepicker>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full" v-else-if="prop == 'dateRangeComplete'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Baş. Tarih
              </span>
              <datepicker placeholder=" Tamamlanma Başlangıç Tarihi" class="w-full filterStartDate" :language="turkish"
                          :format="format" v-model="localTableOptions.dateRangeComplete.startDate">
              </datepicker>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Bit. Tarih
              </span>
              <datepicker placeholder="Tamamlanma Bitiş Tarihi" class="w-full filterEndDate" :language="turkish"
                          :format="format" v-model.lazy="localTableOptions.dateRangeComplete.endDate">
              </datepicker>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full" v-else-if="prop == 'timeRange'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Baş. Saat
              </span>
              <vue-timepicker placeholder="Başlangıç Saati" class="w-full filter-timepicker" :language="turkish"
                              v-model="localTableOptions.timeRange.startTime"></vue-timepicker>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Bit. Saat
              </span>
              <vue-timepicker placeholder="Bitiş Saati" class="w-full filter-timepicker" :language="turkish"
                              v-model.lazy="localTableOptions.timeRange.endTime"></vue-timepicker>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full" @click="fillProductOptions" v-else-if="prop == 'product'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ürün Adı
          </span>
          <v-select class="w-full" placeholder="Ürün Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.product" :options="productNameList"/>
        </div>
        <div class="w-full" v-else-if="prop == 'order'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Sipariş No
          </span>
          <vs-input placeholder="Sipariş No" class="bg-white text-dark w-full" v-model="localTableOptions.order"
                    size="small" v-validate="{regex: /^\d{0,10}$/}"/>
        </div>
        <div class="w-full" @click="fillExtraNameList" v-else-if="prop == 'extra'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ekstra Adı
          </span>
          <v-select class="w-full" placeholder="Ekstra Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.extra" :options="extraNameList"/>
        </div>
        <div class="w-full" @click="fillPersonalNameList" v-else-if="prop == 'personal'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Personel Adı
          </span>
          <v-select class="w-full" placeholder="Personel Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.personal" :options="personalNameList"/>
        </div>
        <div class="w-full" @click="fillPaymentMethodNameList" v-else-if="prop == 'paymentMethod'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ödeme Adı
          </span>
          <v-select class="w-full" placeholder="Ödeme Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.paymentMethod" :options="paymentMethodNameList"/>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'price'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Tutar
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full" v-model="localTableOptions.price.min"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Tutar
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full" v-model="localTableOptions.price.max"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full" v-else-if="prop == 'isNavigatedByQuestion'">
          <vs-checkbox class="mt-2 text-xsmall text-secondary2 weight-600"
                       v-model="localTableOptions.isNavigatedByQuestion">Pasta Sorusu
          </vs-checkbox>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'cost'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Maali.
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full" v-model="localTableOptions.cost.min"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Maali.
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full" v-model="localTableOptions.cost.max"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'oldCost'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Eski Maali.
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full" v-model="localTableOptions.oldCost.min"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Eski Maali.
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full" v-model="localTableOptions.oldCost.max"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'quantity'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Miktar
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full" v-model="localTableOptions.quantity.min"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Miktar
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full" v-model="localTableOptions.quantity.max"
                        size="small" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full" v-else-if="prop == 'stockLogType'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Tip
          </span>
          <v-select class="w-full" itemid="id" label="name" placeholder="Tip Seçimi"
                    v-model="localTableOptions.stockLogType" :options="stockLogTypes"/>
        </div>
        <div class="w-full" @click="fillBranchCodeList" v-else-if="prop == 'branchCode' && ($isCenterBranch() || $isRegionalCenterBranch())">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Şube Kodu
          </span>
          <v-select class="w-full" placeholder="Kod" itemid="id" label="name" v-model="localTableOptions.branchCode"
                    :options="branchCodeList"/>
        </div>
        <div class="w-full" @click="fillRoleList" v-else-if="prop == 'role'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Rol
          </span>
          <v-select class="w-full" placeholder="Rol Seçimi" itemid="id" label="name" v-model="localTableOptions.role"
                    :options="roleList"/>
        </div>
        <div class="w-full" @click="fillHalfMadeList" v-else-if="prop == 'halfMade'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Yarımamül
          </span>
          <v-select class="w-full" placeholder="Yarımamül Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.halfMade" :options="halfMadeList"/>
        </div>
        <div class="w-full" @click="fillUserNameList" v-else-if="prop == 'userName'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Kullanıcı Adı
          </span>
          <v-select class="w-full" placeholder="Kullanıcı Adı Seçimi" v-model="localTableOptions.userName"
                    :options="userNameList"/>
        </div>
        <div class="w-full" @click="fillUserPhoneNumberList" v-else-if="prop == 'userPhoneNumber'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Telefon
          </span>
          <v-select class="w-full" placeholder="Telefon Seçimi" v-model="localTableOptions.userPhoneNumber"
                    :options="userPhoneNumberList"/>
        </div>
        <div class="w-full" v-else-if="prop == 'ticketCode'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Bilet
          </span>
          <vs-input placeholder="Bilet" class="bg-white text-dark w-full" v-model="localTableOptions.ticketCode"
                    size="small"/>
        </div>
        <div class="w-full" @click="fillCustomerPhoneNumbers" v-else-if="prop == 'customerPhoneNumber'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Telefon
          </span>
          <v-select class="w-full" placeholder="Telefon Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.customerPhoneNumber"
                    :options="customerPhoneNumberList"/>
        </div>
        <div class="w-full" @click="fillUserEmailList" v-else-if="prop == 'userEmail'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Email
          </span>
          <v-select class="w-full" placeholder="Email Seçimi" v-model="localTableOptions.userEmail"
                    :options="userEmailList"/>
        </div>
        <div class="w-full" @click="fillCustomerEmails" v-else-if="prop == 'customerEmail'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Email
          </span>
          <v-select class="w-full" placeholder="Email Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.customerEmail"
                    :options="customerEmailList"/>
        </div>
        <div class="w-full" @click="fillDraws" v-else-if="prop == 'draw'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Çekiliş
          </span>
          <v-select class="w-full" placeholder="Çekiliş Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.draw"
                    :options="drawList"/>
        </div>
        <div class="w-full" @click="fillUserTcNumberList" v-else-if="prop == 'userTcNumber'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            T.C
          </span>
          <v-select class="w-full" placeholder="T.C Seçimi" v-model="localTableOptions.userTcNumber"
                    :options="userTcNumberList"/>
        </div>
        <div class="w-full" @click="fillCityList" v-else-if="prop == 'city'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Şehir
          </span>
          <v-select class="w-full" placeholder="Şehir Seçimi" itemid="id" label="name" v-model="localTableOptions.city"
                    :options="cityList"/>
        </div>
        <div class="w-full" @click="fillStateList" v-else-if="prop == 'state'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            İlçe
          </span>
          <v-select class="w-full" placeholder="İlçe Şeçimi" itemid="id" label="name" v-model="localTableOptions.state"
                    :options="stateList" :disabled="localTableOptions.city == null"/>
        </div>
        <div class="w-full" @click="fillBranchEmailList" v-else-if="prop == 'branchEmail'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Email
          </span>
          <v-select class="w-full" placeholder="Email" itemid="id" label="name" v-model="localTableOptions.branchEmail"
                    :options="branchEmailList"/>
        </div>
        <div class="w-full" @click="fillBranchPhoneNumberList" v-else-if="prop == 'branchPhoneNumber'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Telefon
          </span>
          <v-select class="w-full" placeholder="Telefon" itemid="id" label="name"
                    v-model="localTableOptions.branchPhoneNumber" :options="branchPhoneNumberList"/>
        </div>
        <div class="w-full" @click="fillBranchAddressList" v-else-if="prop == 'branchAddress'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Adres
          </span>
          <v-select class="w-full" placeholder="Adres" itemid="id" label="name"
                    v-model="localTableOptions.branchAddress" :options="branchAddressList"/>
        </div>
        <div class="w-full" v-else-if="prop == 'active'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Durum
          </span>
          <v-select class="w-full" placeholder="Durum Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.active"
                    :options="[{id:1,name:'Aktif',value:true},{id:2,name:'Pasif',value:false}]"
                    :reduce="x=> x.value"/>
        </div>
        <div class="w-full" @click="fillExtraOriginList" v-else-if="prop == 'extraOrigin'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ana Ekstra
          </span>
          <v-select class="w-full" placeholder="Ana Ekstra" itemid="id" label="name"
                    v-model="localTableOptions.extraOrigin" :options="extraOriginList"/>
        </div>
        <div class="w-full" @click="fillExpenseDescriptionList" v-else-if="prop == 'expenseDescription'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Açıklama
          </span>
          <v-select class="w-full" placeholder="Açıklama" itemid="id" label="name"
                    v-model="localTableOptions.expenseDescription" :options="expenseDescriptionList"/>
        </div>
        <div class="w-full" @click="fillRawMaterialList" v-else-if="prop == 'rawMaterial'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Hammadde
          </span>
          <v-select class="w-full" placeholder="Hammadde" itemid="id" label="name"
                    v-model="localTableOptions.rawMaterial" :options="rawMaterialList"/>
        </div>
        <div class="w-full" @click="fillRawMaterialCategories" v-else-if="prop == 'rawMaterialCategory'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Hammadde Kat.
          </span>
          <v-select class="w-full" placeholder="Hammadde" itemid="id" label="name"
                    v-model="localTableOptions.rawMaterialCategory" :options="rawMaterialCategoryList"/>
        </div>
        <div class="w-full" @click="fillCategoryList" v-else-if="prop == 'category'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Kategori
          </span>
          <v-select class="w-full" placeholder="Kategori" itemid="id" label="name" v-model="localTableOptions.category"
                    :options="categoryList"/>
        </div>
        <div class="w-full" @click="fillStockList" v-else-if="prop == 'stock'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Stok
          </span>
          <v-select class="w-full" placeholder="Stok" itemid="id" label="name" v-model="localTableOptions.stock"
                    :options="stockList"/>
        </div>
        <div class="w-full" @click="fillStockCodeList" v-else-if="prop == 'stockCode'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Stok Kodu
          </span>
          <v-select class="w-full" placeholder="Kod" v-model="localTableOptions.stockCode" :options="stockCodeList"/>
        </div>
        <div class="w-full" v-else-if="prop == 'isGlobal'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Kapsam
          </span>
          <v-select class="w-full" placeholder="Kapsam" itemid="id" label="name" v-model="localTableOptions.isGlobal"
                    :options="[{id:1,name:'Özel',value:false},{id:2,name:'Genel',value:true}]" :reduce="x=> x.value"/>
        </div>
        <div class="w-full" @click="fillDaysOfWeek" v-else-if="prop == 'daysOfWeek'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Gün
          </span>
          <v-select class="w-full" placeholder="Gün" itemid="id" label="name"
                    v-model="localTableOptions.daysOfWeek" :options="daysOfWeek"/>
        </div>
        <div class="w-full" @click="fillDashboardProps" v-else-if="prop == 'reportByProp'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ölçüt
          </span>
          <v-select class="w-full" placeholder="Ölçüt" itemid="id" label="dName"
                    v-model="localTableOptions.reportByProp" :options="dashboardProps"/>
        </div>
        <div class="w-full" @click="fillDashboardProps" v-else-if="prop == 'hourPeriod'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Saat Aralığı
          </span>
          <vs-input placeholder="Saat" class="bg-white text-dark w-full"
                    v-model="localTableOptions.hourPeriod" size="small"
                    v-validate="{max_value: 12,min_value:1}"/>
        </div>
        <div class="w-full" @click="fillDashboardTimeRanges" v-else-if="prop == 'defaultTimeRange'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Zaman Aralığı
          </span>
          <v-select class="w-full" placeholder="Zaman Aralığı" itemid="id" label="dName"
                    v-model="localTableOptions.defaultTimeRange" :options="dashboardTimeRanges"/>
        </div>
        <div class="w-full" @click="fillSortDirections" v-else-if="prop == 'direction'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Sıralama
          </span>
          <v-select class="w-full" placeholder="Sıralama" itemid="id" label="dName"
                    v-model="localTableOptions.direction" :options="directions"/>
        </div>
        <div class="w-full" @click="fillDistributorList" v-else-if="prop == 'distributor'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Distributor
          </span>
          <v-select class="w-full" placeholder="Distributor" itemid="id" label="name"
                    v-model="localTableOptions.distributor" :options="distributorList"/>
        </div>
        <div class="w-full" @click="fillSupplierList" v-else-if="prop == 'supplier'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Tedarikçi
          </span>
          <v-select class="w-full" placeholder="Tedarikçi" itemid="id" label="name" v-model="localTableOptions.supplier"
                    :options="supplierList"/>
        </div>
        <div class="w-full" @click="fillRecipeList" v-else-if="prop == 'recipe'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Reçete
          </span>
          <v-select class="w-full" placeholder="Reçete Seçimi" itemid="id" label="name"
                    v-model="localTableOptions.recipe" :options="recipeList"/>
        </div>
        <div class="w-full" @click="fillUnitList" v-else-if="prop == 'unit'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Birim
          </span>
          <v-select class="w-full" placeholder="Birim" v-model="localTableOptions.unit" :options="unitList"/>
        </div>
        <div class="w-full" @click="fillUnitOriginList" v-else-if="prop == 'unitOrigin'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ana Birim
          </span>
          <v-select class="w-full" placeholder="Ana Birim" v-model="localTableOptions.unitOrigin"
                    :options="unitOriginList"/>
        </div>
        <div class="w-full" @click="fillUnitOriginQuantityList" v-else-if="prop == 'unitOriginQuantity'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ana Brm. Oran
          </span>
          <v-select class="w-full" placeholder="Birim Oran" v-model="localTableOptions.unitOriginQuantity"
                    :options="unitOriginQuantityList"/>
        </div>
        <div class="w-full" @click="fillUnitShortNameList" v-else-if="prop == 'unitShortName'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Kısa Ad
          </span>
          <v-select class="w-full" placeholder="Kısa Ad" v-model="localTableOptions.unitShortName"
                    :options="unitShortNameList"/>
        </div>
        <div class="w-full" @click="fillDistributorEmailList" v-else-if="prop == 'distributorEmail'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Email
          </span>
          <v-select class="w-full" placeholder="Email" itemid="id" label="name"
                    v-model="localTableOptions.distributorEmail" :options="distributorEmailList"/>
        </div>
        <div class="w-full" @click="fillDistributorPhoneNumberList" v-else-if="prop == 'distributorPhoneNumber'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Telefon
          </span>
          <v-select class="w-full" placeholder="Telefon" itemid="id" label="name"
                    v-model="localTableOptions.distributorPhoneNumber" :options="distributorPhoneNumberList"/>
        </div>
        <div class="w-full" @click="fillDistributorOwnerList" v-else-if="prop == 'distributorOwner'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Yetkili
          </span>
          <v-select class="w-full" placeholder="Yetkili" itemid="id" label="name"
                    v-model="localTableOptions.distributorOwner" :options="distributorOwnerList"/>
        </div>
        <div class="w-full" @click="fillDistributorBankList" v-else-if="prop == 'distributorBank'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Banka
          </span>
          <v-select class="w-full" placeholder="Banka" itemid="id" label="name"
                    v-model="localTableOptions.distributorBank" :options="distributorBankList"/>
        </div>
        <div class="w-full" @click="fillBillNoList" v-else-if="prop == 'billNo'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Fatura No
          </span>
          <v-select class="w-full" placeholder="Fatura No" itemid="id" label="name" v-model="localTableOptions.billNo"
                    :options="billNoList"/>
        </div>
        <div class="w-full" @click="fillDistributorBankAccountList" v-else-if="prop == 'distributorBankAccount'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Banka Hesabı
          </span>
          <v-select class="w-full" placeholder="Banka Hesap" itemid="id" label="name"
                    v-model="localTableOptions.distributorBankAccount" :options="distributorBankAccountList"/>
        </div>
        <div class="w-full" @click="fillDistributorAddressList" v-else-if="prop == 'distributorAddress'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Adres
          </span>
          <v-select class="w-full" placeholder="Adres" itemid="id" label="name"
                    v-model="localTableOptions.distributorAddress" :options="distributorAddressList"/>
        </div>
        <div class="w-full" @click="fillExpenseDefinitionList" v-else-if="prop == 'expenseDefinition'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Tanım
          </span>
          <v-select class="w-full" placeholder="Tanım" itemid="id" label="name"
                    v-model="localTableOptions.expenseDefinition" :options="expenseDefinitionList"/>
        </div>
        <div class="w-full" @click="fillLossDescriptionList" v-else-if="prop == 'lossDescription'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Açıklama
          </span>
          <v-select class="w-full" placeholder="Açıklama" v-model="localTableOptions.lossDescription"
                    :options="lossDescriptionList"/>
        </div>
        <div class="w-full" @click="fillRawMaterialDescriptionList" v-else-if="prop == 'rawMaterialDescription'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Açıklama
          </span>
          <v-select class="w-full" placeholder="Açıklama" v-model="localTableOptions.rawMaterialDescription"
                    :options="rawMaterialDescriptionList"/>
        </div>
        <div class="w-full" @click="fillKdvList" v-else-if="prop == 'kdv'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Kdv
          </span>
          <v-select class="w-full" placeholder="Kdv" v-model="localTableOptions.kdv" :options="kdvList"/>
        </div>
        <div class="w-full" @click="fillStockOrderList" v-else-if="prop == 'stockOrder'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Sipariş
          </span>
          <v-select class="w-full" placeholder="Sipariş" itemid="id" label="name" v-model="localTableOptions.stockOrder"
                    :options="stockOrderList"/>
        </div>
        <div class="w-full" @click="fillVariantList" v-else-if="prop == 'variant'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Variant
          </span>
          <v-select class="w-full" placeholder="Variant" itemid="id" label="name" v-model="localTableOptions.variant"
                    :options="variantList"/>
        </div>
        <div class="w-full" @click="fillSupplierEmailList" v-else-if="prop == 'supplierEmail'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Email
          </span>
          <v-select class="w-full" placeholder="Email" v-model="localTableOptions.supplierEmail"
                    :options="supplierEmailList"/>
        </div>
        <div class="w-full" @click="fillStockOrderStatus" v-else-if="prop == 'stockOrderStatus'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Durum
          </span>
          <v-select class="w-full" placeholder="Durum" itemid="id" label="name"
                    v-model="localTableOptions.stockOrderStatus" :options="stockOrderStatus"/>
        </div>
        <div class="w-full" @click="fillSupplierPhoneNumberList" v-else-if="prop == 'supplierPhoneNumber'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Telefon
          </span>
          <v-select class="w-full" placeholder="Telefon" v-model="localTableOptions.supplierPhoneNumber"
                    :options="supplierPhoneNumberList"/>
        </div>
        <div class="w-full" @click="fillSupplierOwnerList" v-else-if="prop == 'supplierOwner'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Yetkili
          </span>
          <v-select class="w-full" placeholder="Yetkili" v-model="localTableOptions.supplierOwner"
                    :options="supplierOwnerList"/>
        </div>
        <div class="w-full" @click="fillSupplierBankList" v-else-if="prop == 'supplierBank'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Banka
          </span>
          <v-select class="w-full" placeholder="Banka" v-model="localTableOptions.supplierBank"
                    :options="supplierBankList"/>
        </div>
        <div class="w-full" @click="fillSupplierBankAccountList" v-else-if="prop == 'supplierBankAccount'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Banka Hesabı
          </span>
          <v-select class="w-full" placeholder="Banka Hesabı" v-model="localTableOptions.supplierBankAccount"
                    :options="supplierBankAccountList"/>
        </div>
        <div class="w-full" v-else-if="prop == 'month'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Ay
          </span>
          <v-select class="w-full" placeholder="Ay" itemid="id" label="name" v-model="localTableOptions.month"
                    :options="$months()"/>
        </div>
        <div class="w-full" v-else-if="prop == 'year'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Yıl
          </span>
          <v-select class="w-full" placeholder="Yıl" itemid="id" label="name" v-model="localTableOptions.year"
                    :options="$years()"/>
        </div>
        <div class="w-full" v-else-if="prop == 'billStatus'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Durum
          </span>
          <v-select class="w-full" placeholder="Durum" itemid="id" label="name" v-model="localTableOptions.billStatus"
                    :options="billStatuses"/>
        </div>
        <div class="w-full" @click="fillDiscountDescriptions" v-else-if="prop == 'discountDescription'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Açıklama
          </span>
          <v-select class="w-full" placeholder="Açıklama" itemid="id" label="name"
                    v-model="localTableOptions.discountDescription" :options="discountDescriptionList"/>
        </div>
        <div class="w-full" v-else-if="prop == 'fullDiscount'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Tip
          </span>
          <v-select class="w-full" placeholder="Tip" itemid="id" label="name"
                    v-model="localTableOptions.fullDiscount" :options="discountTypes"/>
        </div>
        <div class="w-full" v-else-if="prop == 'queueStatus'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Tip
          </span>
          <v-select class="w-full" placeholder="Güncelleme Durumu" itemid="id" label="name"
                    v-model="localTableOptions.queueStatus" :options="queueStatuses"/>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'rangePreTransfer'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Ay Devir
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangePreTransfer.min" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Ay Devir
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangePreTransfer.max" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'rangeCurrSaved'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Eklenen
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeCurrSaved.min" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Eklenen
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeCurrSaved.max" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'rangeCurrConsume'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Harcanan
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeCurrConsume.min" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Harcanan
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeCurrConsume.max" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'rangeCurrLeft'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Kalan
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeCurrLeft.min" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Kalan
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeCurrLeft.max" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full d-flex" v-else-if="prop == 'rangeNumber'">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">
                Min Sonuç
              </span>
              <vs-input placeholder="Minimum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeNumber.min" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">
                Max Sonuç
              </span>
              <vs-input placeholder="Maximum" class="bg-white text-dark w-full"
                        v-model="localTableOptions.rangeNumber.max" size="small"
                        v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="w-full" @click="fillSupplierAddressList" v-else-if="prop == 'supplierAddress'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Adres
          </span>
          <v-select class="w-full" placeholder="Adres" v-model="localTableOptions.supplierAddress"
                    :options="supplierAddressList"/>
        </div>
        <div class="w-full" @click="fillLossReasonList" v-else-if="prop == 'lossReason'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Sebep
          </span>
          <v-select class="w-full" placeholder="Sebep" itemid="id" label="name" v-model="localTableOptions.lossReason"
                    :options="lossReasonList"/>
        </div>
        <div class="w-full" v-if="prop == 'DayReportType'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Gün Raporu Tipi
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="Rapor Tipi Seçimi" v-model="localTableOptions.dayReportType"
                     :clearable="true" :options="[{'id':0,'name':'Gün Açılışı'},{'id':1,'name':'Gün Ortası'},
                    {'id':2,'name':'Gün Kapanışı'}]">
                    </v-select>
        </div>
        <div class="w-full" v-if="prop == 'UserWantStatus'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            İstek Durumu
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="İstek Durumu Seçimi" v-model="localTableOptions.userWantStatus"
                     :clearable="true" :options="[{'id':0,'name':'İletildi'},{'id':1,'name':'Süreç Başladı'},
                    {'id':2,'name':'Tamamlandı'}]">
                    </v-select>
        </div>
        <div class="w-full" v-if="prop == 'actionType'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            İşlem Türü
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="İşlem Türü Seçimi" v-model="localTableOptions.actionType"
                     :clearable="true" :options="actionTypes">
          </v-select>
        </div>
        <div class="w-full" v-if="prop == 'isOpenBill'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Adisyon Durumu
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="Durum Seçimi" v-model="localTableOptions.isOpenBill"
                     :clearable="true" :options="isOpenBillStatusOptions">
          </v-select>
        </div>
        <div class="w-full" @click="fillTableList" v-if="prop == 'table'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Masa
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="Masa Seçimi" v-model="localTableOptions.table"
                     :clearable="true" :options="tableList">
          </v-select>
        </div>
        <div class="w-full" @click="fillTableList" v-if="prop == 'targetTable'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Hedef Masa
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="Hedef Masa Seçimi" v-model="localTableOptions.targetTable"
                     :clearable="true" :options="tableList">
          </v-select>
        </div>
        <div class="w-full" v-if="prop == 'quantityType'">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">
            Miktar Türü
          </span>
          <v-select itemid="id" label="name" class="w-full" placeholder="Miktar Türü Seçimi" v-model="localTableOptions.quantityType"
                     :options="quantityTypes" :reduce="x => x.id">
          </v-select>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" class="ml-auto px-1 py-2" vs-w="2.2"
              vs-sm="6">
        <vs-button @click="undoChanges" icon-pack="feather" icon="icon-rewind" size="small" color="warning"
                   :class="{'mt-5' : filterOptions.length % 5 != 0}" class="mr-1 w-full text-light">
          Geri
        </vs-button>
        <vs-button @click="submitFilter" icon-pack="feather" icon="icon-search" class="w-full"
                   :class="{'mt-5' : filterOptions.length % 5 != 0}" color="primary" size="small"
                   style="max-width:120px;">
          Ara
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import {
  getDashboardProps,
  getDaysOfWeek,
  getDashboardTimeRanges,
  getSortDirections
} from "@/model/constants/dashboardModels.js";
import {
  getStockOrderStatus
} from "@/model/constants/stockOrderStatus.js";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import {
  tr
} from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import {
  filterStockOrderList,
  filterBranchNameList,
  filterProductNameList,
  filterUnitList,
  filterUnitOriginList,
  filterUnitOriginQuantityList,
  filterUnitShortNameList,
  filterOrderList,
  filterBillNoList,
  filterExtraNameList,
  filterPersonalNameList,
  filterPaymentMethodNameList,
  filterBranchCodeList,
  filterBranchCodeListForDealer,
  filterDrawList,
  filterStateList,
  filterCityList,
  filterBranchEmailList,
  filterExtraOriginList,
  filterBranchPhoneNumberList,
  filterBranchAddressList,
  filterExpenseDescriptionList,
  filterExpenseDefinitionList,
  filterLossDescriptionList,
  filterLossReasonList,
  filterRawMaterialList,
  filterStockCodeList,
  filterStockList,
  filterCategoryList,
  filterSupplierList,
  filterUserTcNumbersList,
  filterUserNameList,
  filterUserPhoneNumbersList,
  filterUserEmailList,
  filterHalfMadeList,
  filterRoleList,
  filterDistributorList,
  filterSupplierAddressList,
  filterSupplierBankAccountList,
  filterSupplierBankList,
  filterSupplierOwnerList,
  filterSupplierPhoneNumberList,
  filterSupplierEmailList,
  filterRawMaterialDescriptionList,
  filterKdvList,
  filterRecipeList,
  filterVariantList,
  filterDistributorEmailList,
  filterDistributorPhoneNumberList,
  filterDistributorOwnerList,
  filterDistributorBankList,
  filterDistributorBankAccountList,
  filterDistributorAddressList,
  filterDiscountDescriptionList,
  filterRawMaterialCategoryList,
  filterCustomerEmailList,
  filterCustomerPhoneNumberList,
  filterTableList
} from "@/api/Filter"

export default {
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    tableOptions: {
      type: Object,
      required: true
    },
    filterOptions: {
      type: Array,
      required: true
    },
    filterChips: {
      type: Array,
      required: true
    },
    filterOptionNames: {
      type: Array,
      required: true
    }
  },
  components: {
    VueTimepicker,
    Datepicker
  },
  data() {
    return {
      format: "dd MM yyyy",
      turkish: tr,
      localTableOptions: {},
      monthNames: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Arl'],
      branchNameList: [],
      productNameList: [],
      orderList: [],
      extraNameList: [],
      personalNameList: [],
      paymentMethodNameList: [],
      roleList: [],
      userEmailList: [],
      userPhoneNumberList: [],
      userTcNumberList: [],
      branchCodeList: [],
      branchPhoneNumberList: [],
      branchAddressList: [],
      billNoList: [],
      branchEmailList: [],
      stockOrderList: [],
      stateList: [],
      extraOriginList: [],
      cityList: [],
      recipeList: [],
      rawMaterialCategoryList: [],
      distributorEmailList: [],
      customerEmailList: [],
      customerPhoneNumberList: [],
      tableList: [],
      discountTypes: [
        {
          id: 0,
          name: "Hepsi",
          value: null
        },
        {
          id: 1,
          name: "İndirim",
          value: false
        },
        {
          id: 2,
          name: "İkram",
          value: true
        }
      ],
      discountDescriptionList: [],
      stockLogTypes: [{
        id: "Exit",
        name: "Çıkış"
      },
        {
          id: "Enter",
          name: "Giriş"
        }
      ],
      billStatuses: [{
        id: "InComplete",
        name: "Bekleyen"
      },
        {
          id: "Complete",
          name: "Tamamlanmış"
        }
      ],
      queueStatuses: [
        {id: 0, name: "Error"},
        {id: 1, name: "Cancelled"},
        {id: 2, name: "Await"},
        {id: 3, name: "Pending"},
        {id: 4, name: "Completed"}
      ],
      categoryList: [],
      distributorPhoneNumberList: [],
      halfMadeList: [],
      distributorOwnerList: [],
      distributorBankList: [],
      dashboardTimeRanges: [],
      dashboardProps: [],
      daysOfWeek: [],
      directions: [],
      distributorBankAccountList: [],
      distributorAddressList: [],
      rawMaterialList: [],
      expenseDescriptionList: [],
      expenseDefinitionList: [],
      lossDescriptionList: [],
      lossReasonList: [],
      distributorList: [],
      supplierList: [],
      unitList: [],
      unitOriginList: [],
      unitOriginQuantityList: [],
      unitShortNameList: [],
      userNameList: [],
      supplierAddressList: [],
      supplierPhoneNumberList: [],
      supplierBankList: [],
      supplierBankAccountList: [],
      supplierOwnerList: [],
      supplierEmailList: [],
      stockList: [],
      stockOrderStatus: [],
      stockCodeList: [],
      rawMaterialDescriptionList: [],
      kdvList: [],
      variantList: [],
      drawList: [],
      actionTypes: [
        { id: 'Add', name: 'Ekleme' },
        { id: 'Cancel', name: 'İptal' },
        { id: 'Transfer', name: 'Transfer' },
        { id: 'Merge', name: 'Birleştirme' },
        { id: 'Separation', name: 'Ayırma' },
        { id: 'Discount', name: 'İndirim' },
        { id: 'Treat', name: 'İkram' },
        { id: 'ChangePaymentMethod', name: 'Ödeme Şekli Değişimi' },
        { id: 'TimeChange', name: 'Süre Değişimi' }
      ],
      isOpenBillStatusOptions: [
        { id: 1, name: 'Açık Masalar', value: true },
        { id: 2, name: 'Kapanmış Siparişler', value: false }
      ],
      quantityTypes: [
        { id: 0, name: 'Adetli' },
        { id: 1, name: 'Süreli' }
      ],
      ticketCode: null,
      filterIgnoredProperties: ['sortBy', 'sortDirection', 'pageIndex', 'pageSize', 'takeCount', undefined, null, '']
    }
  },
  computed: {
    toBranchId() {
      if (this.localTableOptions.branch != null) {
        return this.localTableOptions.branch.id;
      }
      if (this.$currentUser && this.$currentUser.branch) {
        return this.$currentUser.branch.id;
      }
      return null;
    },
  },
  methods: {
    convertTurkishDate(date) {
      if (!date) return "";
      let localDate = new Date(date);
      return localDate.getDate() + ' ' + this.monthNames[localDate.getMonth()]
    },
    submitFilter: async function () {
      let checker;
      checker = await this.$validator.validateAll();
      if (!checker) return;
      let filterChips = [];
      for (var option in this.localTableOptions) {
        if (this.localTableOptions[option] == null || (this.filterIgnoredProperties.some(x => x == option) || (
          typeof this.localTableOptions[option] == 'object' ? this
            .$isNullOrEmpty.props(this.localTableOptions[
              option]) : false))) continue;
        let filterOptionIndex = this.filterOptions.findIndex(x => x && x.toLowerCase() == option.toLowerCase());
        if (filterOptionIndex === -1) continue;
        let chip = {};
        chip.col = option;
        chip.name = this.filterOptionNames[filterOptionIndex];
        let tableOptionsKeys = Object.keys(this.localTableOptions[option]);
        if (tableOptionsKeys.some(x => x == 'startDate') && tableOptionsKeys.some(x => x == 'endDate')) chip.value =
          this.convertTurkishDate(this.localTableOptions[option].startDate) + ' - ' + this.convertTurkishDate(this
            .localTableOptions[option].endDate);
        else if (tableOptionsKeys.some(x => x == 'startTime') && tableOptionsKeys.some(x => x == 'endTime'))
          if (!this.$isNullOrEmpty(this.localTableOptions[option].startTime) && this.$isNullOrEmpty(this
            .localTableOptions[option].endTime)) chip.value = this.localTableOptions[option].startTime.HH + ':' +
            this.localTableOptions[option].startTime.mm + ' - ';
          else if (this.$isNullOrEmpty(this.localTableOptions[option].startTime) && !this.$isNullOrEmpty(this
            .localTableOptions[option].endTime)) chip.value = ' - ' + this.localTableOptions[option].endTime.HH +
            ':' + this.localTableOptions[option].endTime.mm;
          else chip
              .value = this.localTableOptions[option].startTime.HH + ':' + this.localTableOptions[option].startTime.mm +
              ' - ' + this.localTableOptions[option]
                .endTime.HH + ':' + this.localTableOptions[option]
                .endTime.mm;
        else if (tableOptionsKeys.some(x => x == 'min') && tableOptionsKeys.some(x => x == 'max')) {
          if (!this.$isNullOrEmpty(this.localTableOptions[option].min) && this.$isNullOrEmpty(this.localTableOptions[
            option].max)) chip.value = 'Min ' + this.localTableOptions[option].min;
          else if (this.$isNullOrEmpty(this.localTableOptions[option].min) && !this.$isNullOrEmpty(this
            .localTableOptions[option].max)) chip.value = 'Max ' + this.localTableOptions[option].max;
          else chip.value = this.localTableOptions[option].min + ' - ' + this.localTableOptions[option].max;
        } else if (tableOptionsKeys.some(x => x == 'id') && tableOptionsKeys.some(x => x == 'name')) {
          if (tableOptionsKeys.some(x => x == 'dName')) chip.value = this
            .localTableOptions[option].dName;
          else chip.value = this
            .localTableOptions[option].name;
        } else if (typeof this.tableOptions[option] !== Object) {
          if (option == 'active') chip.value = this.localTableOptions[option] ? 'Aktif' : 'Pasif';
          else chip.value = this.localTableOptions[option];
        } else continue;

        filterChips.push(chip);
      }
      this.$emit("saveOptions", this.localTableOptions, filterChips);
    },
    undoChanges() {
      this.localTableOptions = _.cloneDeep(this.tableOptions);
    },
    fillBranchOptions: async function () {
      if (this.branchNameList.length == 0) this.branchNameList = await filterBranchNameList();
      if (this.filterOptions.hasOwnProperty("personal"))
        this.personalNameList = await filterPersonalNameList(this.toBranchId);
    },
    fillProductOptions: async function () {
      if (this.productNameList.length == 0) this.productNameList = await filterProductNameList();
    },
    fillOrderOptions: async function () {
      if (this.orderList.length == 0) this.orderList = await filterOrderList(this.toBranchId)
    },
    fillExtraNameList: async function () {
      if (this.extraNameList.length == 0) this.extraNameList = await filterExtraNameList();
    },
    fillPersonalNameList: async function () {
      this.personalNameList = await filterPersonalNameList(this.toBranchId);
    },
    fillPaymentMethodNameList: async function () {
      if (this.paymentMethodNameList.length == 0) this.paymentMethodNameList = await filterPaymentMethodNameList();
    },
    fillBranchCodeList: async function () {
      if (this.$isRegionalCenterBranch()) {
        if (this.branchCodeList.length == 0) this.branchCodeList = await filterBranchCodeListForDealer();
      } else {
        if (this.branchCodeList.length == 0) this.branchCodeList = await filterBranchCodeList();
      }
      
    },
    fillBranchEmailList: async function () {
      if (this.branchEmailList.length == 0) this.branchEmailList = await filterBranchEmailList();
    },
    fillBranchPhoneNumberList: async function () {
      if (this.branchPhoneNumberList.length == 0) this.branchPhoneNumberList = await filterBranchPhoneNumberList();
    },
    fillBranchAddressList: async function () {
      if (this.branchAddressList.length == 0) this.branchAddressList = await filterBranchAddressList();
    },
    fillStateList: async function () {
      if (this.stateList.length == 0) this.stateList = await filterStateList(this.tableOptions.city.id);
    },
    fillCityList: async function () {
      if (this.cityList.length == 0) this.cityList = await filterCityList();
    },
    fillRawMaterialList: async function () {
      if (this.rawMaterialList.length == 0) this.rawMaterialList = await filterRawMaterialList();
    },
    fillExpenseDescriptionList: async function () {
      if (this.expenseDescriptionList.length == 0) this.expenseDescriptionList =
        await filterExpenseDescriptionList();
    },
    fillExpenseDefinitionList: async function () {
      if (this.expenseDefinitionList.length == 0) this.expenseDefinitionList = await filterExpenseDefinitionList();
    },
    fillLossDescriptionList: async function () {
      if (this.lossDescriptionList.length == 0) this.lossDescriptionList = await filterLossDescriptionList(this
        .toBranchId);
    },
    fillLossReasonList: async function () {
      if (this.lossReasonList.length == 0) this.lossReasonList = await filterLossReasonList();
    },
    fillStockList: async function () {
      if (this.stockList.length == 0) this.stockList = await filterStockList(this.toBranchId);
    },
    fillStockCodeList: async function () {
      if (this.stockCodeList.length == 0) this.stockCodeList = await filterStockCodeList(this.toBranchId);
    },
    fillDistributorList: async function () {
      if (this.distributorList.length == 0) this.distributorList = await filterDistributorList();
    },
    fillSupplierList: async function () {
      if (this.supplierList.length == 0) this.supplierList = await filterSupplierList();
    },
    fillSupplierEmailList: async function () {
      if (this.supplierEmailList.length == 0) this.supplierEmailList = await filterSupplierEmailList();
    },
    fillSupplierPhoneNumberList: async function () {
      if (this.supplierPhoneNumberList.length == 0) this.supplierPhoneNumberList =
        await filterSupplierPhoneNumberList();
    },
    fillSupplierOwnerList: async function () {
      if (this.supplierOwnerList.length == 0) this.supplierOwnerList = await filterSupplierOwnerList();
    },
    fillSupplierBankList: async function () {
      if (this.supplierBankList.length == 0) this.supplierBankList = await filterSupplierBankList();
    },
    fillSupplierBankAccountList: async function () {
      if (this.supplierBankAccountList.length == 0) this.supplierBankAccountList =
        await filterSupplierBankAccountList();
    },
    fillSupplierAddressList: async function () {
      if (this.supplierAddressList.length == 0) this.supplierAddressList = await filterSupplierAddressList();
    },
    fillRawMaterialDescriptionList: async function () {
      if (this.rawMaterialDescriptionList.length == 0) this.rawMaterialDescriptionList =
        await filterRawMaterialDescriptionList();
    },
    fillKdvList: async function () {
      if (this.kdvList.length == 0) this.kdvList = await filterKdvList();
    },
    fillVariantList: async function () {
      if (this.variantList == 0) this.variantList = await filterVariantList();
    },
    fillStockOrderStatus: async function () {
      if (this.stockOrderStatus.length == 0) this.stockOrderStatus = getStockOrderStatus();
    },
    fillStockOrderList: async function () {
      if (this.stockOrderList.length == 0) this.stockOrderList = await filterStockOrderList(this.toBranchId);
    },
    fillDistributorEmailList: async function () {
      if (this.distributorEmailList.length == 0) this.distributorEmailList = await filterDistributorEmailList();
    },
    fillDistributorPhoneNumberList: async function () {
      if (this.distributorPhoneNumberList.length == 0) this.distributorPhoneNumberList =
        await filterDistributorPhoneNumberList();
    },
    fillDistributorOwnerList: async function () {
      if (this.distributorOwnerList.length == 0) this.distributorOwnerList = await filterDistributorOwnerList();
    },
    fillDistributorBankList: async function () {
      if (this.distributorBankList.length == 0) this.distributorBankList = await filterDistributorBankList();
    },
    fillDistributorBankAccountList: async function () {
      if (this.distributorBankAccountList.length == 0) this.distributorBankAccountList =
        await filterDistributorBankAccountList()
    },
    fillDistributorAddressList: async function () {
      if (this.distributorAddressList.length == 0) this.distributorAddressList =
        await filterDistributorAddressList();
    },
    fillUnitList: async function () {
      if (this.unitList.length == 0) this.unitList = await filterUnitList();
    },
    fillUnitOriginList: async function () {
      if (this.unitOriginList.length == 0) this.unitOriginList = await filterUnitOriginList();
    },
    fillUnitShortNameList: async function () {
      if (this.unitShortNameList.length == 0) this.unitShortNameList = await filterUnitShortNameList();
    },
    fillUnitOriginQuantityList: async function () {
      if (this.unitOriginQuantityList.length == 0) this.unitOriginQuantityList =
        await filterUnitOriginQuantityList();
    },
    fillUserNameList: async function () {
      if (this.userNameList.length == 0) this.userNameList = await filterUserNameList(this.toBranchId);
    },
    fillUserPhoneNumberList: async function () {
      if (this.userPhoneNumberList.length == 0) this.userPhoneNumberList = await filterUserPhoneNumbersList(this
        .toBranchId);
    },
    fillUserTcNumberList: async function () {
      if (this.userTcNumberList.length == 0) this.userTcNumberList = await filterUserTcNumbersList(this.toBranchId);
    },
    fillUserEmailList: async function () {
      if (this.userEmailList.length == 0) this.userEmailList = await filterUserEmailList(this.toBranchId);
    },
    fillRoleList: async function () {
      if (this.roleList.length == 0) this.roleList = await filterRoleList();
    },
    fillExtraOriginList: async function () {
      if (this.extraOriginList.length == 0) this.extraOriginList = await filterExtraOriginList();
    },
    fillRecipeList: async function () {
      if (this.recipeList.length == 0) this.recipeList = await filterRecipeList();
    },
    fillHalfMadeList: async function () {
      if (this.halfMadeList.length == 0) this.halfMadeList = await filterHalfMadeList();
    },
    fillCategoryList: async function () {
      if (this.categoryList.length == 0) this.categoryList = await filterCategoryList();
    },
    fillBillNoList: async function () {
      if (this.billNoList.length == 0) this.billNoList = await filterBillNoList(this.toBranchId);
    },
    fillDashboardProps: function () {
      if (this.dashboardProps.length == 0) this.dashboardProps = getDashboardProps();
    },
    fillDaysOfWeek: function () {
      if (this.daysOfWeek.length == 0) this.daysOfWeek = getDaysOfWeek();
    },
    fillDashboardTimeRanges: function () {
      if (this.dashboardTimeRanges.length == 0) this.dashboardTimeRanges = getDashboardTimeRanges();
    },
    fillSortDirections: function () {
      if (this.directions.length == 0) this.directions = getSortDirections();
    },
    fillDiscountDescriptions: async function () {
      if (this.discountDescriptionList.length === 0) this.discountDescriptionList = await filterDiscountDescriptionList();
    },
    fillRawMaterialCategories: async function () {
      if (this.rawMaterialCategoryList.length === 0) this.rawMaterialCategoryList = await filterRawMaterialCategoryList();
    },
    fillCustomerEmails: async function () {
      if (this.customerEmailList.length === 0) this.customerEmailList = await filterCustomerEmailList();
    },
    fillCustomerPhoneNumbers: async function () {
      if (this.customerPhoneNumberList.length === 0) this.customerPhoneNumberList = await filterCustomerPhoneNumberList();
    },
    fillDraws: async function () {
      if (this.drawList.length === 0) this.drawList = await filterDrawList();
    },
    fillTableList: async function () {
      if (this.tableList.length === 0) this.tableList = await filterTableList(this.toBranchId);
    },
    closeFilter() {
      this.$emit("close");
    },
  },
  watch: {
    isActive(val) {
      if (val) {
        this.localTableOptions = _.cloneDeep(this.tableOptions);
        if (this.tableOptions.timeRange == null) this.localTableOptions.timeRange = {
          startTime: null,
          endTime: null
        };
        if (this.tableOptions.dateRange == null) this.localTableOptions.dateRange = {
          startDate: null,
          endDate: null,
        };
      }
    },
    'localTableOptions.defaultTimeRange': function (val) {
      this.localTableOptions.dateRange.startDate = null;
      this.localTableOptions.dateRange.endDate = null;
      let dateRangeIndex = this.filterIgnoredProperties.findIndex(y => y == 'dateRange')
      if (val && dateRangeIndex === -1) {
        this.filterIgnoredProperties.push('dateRange');
      } else if (!val && dateRangeIndex >= 0) {
        this.filterIgnoredProperties.splice(dateRangeIndex, 1)
      }
    },
    'localTableOptions.branch.id': function (val, oldVal) {
      if (val !== oldVal) {
        this.stockOrderList.length = 0;
        this.localTableOptions.stockOrderId = null;
        this.orderList.length = 0;
        this.localTableOptions.order = null;
        this.personalNameList.length = 0;
        this.localTableOptions.personal = null;
        this.stockList.length = 0;
        this.localTableOptions.stock = null;
        this.billNoList.length = 0;
        this.localTableOptions.billNo = null;
        this.tableList.length = 0;
        this.localTableOptions.table = null;
        this.localTableOptions.targetTable = null;
      }
    },
    'localTableOptions.city.id': function (val) {
      if (!val) return;
      this.stateList = [];
      this.fillStateList();
    },
    'localTableOptions.timeRange.startTime': function (val) {
      if (!val) return;
      if (val.HH == '' && val.mm == '') {
        this.localTableOptions.timeRange.startTime = null;
      } else if (val.HH && !val.mm) {
        this.localTableOptions.timeRange.startTime.mm = "00";
      } else if (val.mm && !val.HH) {
        this.localTableOptions.timeRange.startTime.HH = "00";
      }
    },
    'localTableOptions.timeRange.endTime': function (val) {
      if (!val) return;
      if (val.HH == '' && val.mm == '') {
        this.localTableOptions.timeRange.endTime = null;
      } else if (val.HH && !val.mm) {
        this.localTableOptions.timeRange.endTime.mm = "00";
      } else if (val.mm && !val.HH) {
        this.localTableOptions.timeRange.endTime.HH = "00";
      }
    },
  },
  created() {
    if (!this.$isCenterBranch()) {
      if (!this.$isRegionalCenterBranch()) {
        this.filterIgnoredProperties.push('branch');
      }
    }
  }
}

</script>

<style lang="css">
#globalFilterContent .vdp-datepicker input {
  padding: 0.55rem !important
}

@media only screen and (max-width: 768px) {

  #globalFilterContent .vdp-datepicker {
    position: static;
  }

  #globalFilterContent .vdp-datepicker .vdp-datepicker__calendar {
    position: fixed;
    left: calc(50% - 100.5px);
  }
}

#globalFilterContent input {
  font-size: 12px !important;
}

#globalFilterContent .vdp-datepicker__calendar .cell {
  font-size: 70% !important;
  padding: 0 !important;
}

#globalFilterContent .vdp-datepicker__calendar {
  width: 201px !important;
}

#globalFilterContent .vdp-datepicker .cell.day {
  font-size: 12px !important;
  height: 25px !important;
  line-height: 23px !important;
}

#globalFilterContent .vs__dropdown-menu {
  max-height: 26vh !important;
  position: absolute !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  min-width: unset !important;
  width: 100% !important;
  font-size: 12px !important;
}

#globalFilterContent .vs__selected {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 96%;
  text-overflow: ellipsis;
  display: block;
}

#globalFilterContent .vue__time-picker .dropdown,
#globalFilterContent .vue__time-picker .dropdown .select-list {
  width: 8em !important;
  z-index: 500000000 !important;
}

#globalFilterContent .vue__time-picker .dropdown ul li {
  padding: .15em 0 !important;
  font-size: 12px;
}

#globalFilterContent .filter-timepicker input {
  width: 100% !important;
  border-radius: 5px;
  background: white;
  height: unset !important;
  padding-top: 9px !important;
  padding-bottom: 9px !important;
  padding-left: 11px !important;
}

#globalFilterContent .vs__selected-options {
  max-width: 86%;
  flex-wrap: nowrap !important;
}

#globalFilterContent .vs__search {
  width: 0;
  padding: 0;
  margin-bottom: 4px;
}

#globalFilterContent .v-select .vs__dropdown-toggle {
  display: -webkit-box !important;
}

#globalFilterContent .vs-con-input .vs-inputx {
  padding: 0.5rem 0.4rem !important;
}
</style>
